import { cloneDeep } from 'es-toolkit';

type Form = Record<string, unknown>;

export type PostProcessFormOpts = {
  replaceEmptyStrings: boolean;
  emptyValueToSet: null | undefined;
}

const isForm = (value: unknown): value is Form => !Array.isArray(value)
  && typeof value === 'object'
  && value !== null;

export const process = (form: Form, opts: PostProcessFormOpts) => {
  Object.entries(form).forEach(([key, value]) => {
    const isNestedForm = isForm(value);

    if (isNestedForm) {
      process(value, opts);
      return;
    }

    const stringMustBeReplaced = opts.replaceEmptyStrings
      && typeof value === 'string'
      && value.length === 0;

    if (stringMustBeReplaced) {
      // eslint-disable-next-line no-param-reassign
      form[key] = opts.emptyValueToSet;
    }
  });
};

export const postProcessForm = <T extends Form>(form: T, opts: PostProcessFormOpts = {
  replaceEmptyStrings: true,
  emptyValueToSet: undefined,
}): T => {
  const copy = cloneDeep(form);
  process(copy, opts);
  return copy;
};
